<script>
  export let cardProps = "";
  export let headerTitle = "";
  export let cardHeaderprops = "";
  export let cardBodyprops ="";
  export let cardFooterprops ="";
</script>

<div class="card {cardProps}">
  {#if cardHeaderprops || headerTitle || $$slots.customheader }
    <div class="card-header {cardHeaderprops}">
      {#if headerTitle }
        <h5>{headerTitle}</h5>
      {/if}
      {#if $$slots.customheader}
          <slot name="customheader" />
      {/if}
    </div>
  {/if}
  {#if $$slots.customheader2}
    <slot name="customheader2"/>
  {/if}
  {#if $$slots.contentbody}
    <div class="card-body {cardBodyprops}">
      <slot name="contentbody"/>
    </div>
  {/if}
  {#if $$slots.contentfooter}
    <div class="card-footer {cardFooterprops}">
      <slot name="contentfooter"/>
    </div>
  {/if}
</div>